import { render, staticRenderFns } from "./m-message-redirect-package-dialog.vue?vue&type=template&id=48e98cf9&scoped=true&"
import script from "./m-message-redirect-package-dialog.vue?vue&type=script&lang=js&"
export * from "./m-message-redirect-package-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e98cf9",
  null
  
)

export default component.exports